import { Button, Toaster } from "@jana-technology/platform-ui";

import { ExportSelect } from "components/selects/ExportSelect";
import { useExportContext } from "contexts/export/context";

export const ExportPage = () => {
  const {
    reportTypes,
    selectedReportType,
    setSelectedReportType,
    fetchExportData,
  } = useExportContext();

  return (
    <div>
      <form
        id="export-form"
        name="export-form"
        onSubmit={(event) => {
          event.preventDefault();

          void fetchExportData(selectedReportType);
        }}
      >
        <div className="flex items-end gap-4">
          <ExportSelect
            label="Report Type*:"
            items={reportTypes}
            value={selectedReportType}
            onValueChange={setSelectedReportType}
          />
          <Button type="submit">Export</Button>
        </div>
      </form>
      <Toaster />
    </div>
  );
};

export default ExportPage;
